<template>
    <div v-if="isVisible" class="modal-overlay">
        <div class="modal">
            <div class="modal-header">
                <h3>{{ title }}</h3>
                <button @click="closeModal" class="btn-close">&times;</button>
            </div>
            <div class="modal-body">
                <p v-if="errors.length" class="validation">
                    <b>Bitte die folgenden Fehler korrigieren:</b>
                    <ul>
                        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                    </ul>
                </p>
                <div class="form-create">
                    <form @submit.prevent="saveSickDay">
                        <div>
                            <label>Erster Tag</label>
                            <input type="date" v-model="sickDay.startDate">
                        </div>
                        <div>
                            <label>Letzter Tag</label>
                            <input type="date" v-model="sickDay.endDate">
                        </div>
                        <div>
                            <label>Arbeitsunfähigkeitsbescheinigung?</label>
                            <select v-model="sickDay.attested">
                                <option disabled :value="null">Bitte auswählen...</option>
                                <option :value="true">Ja</option>
                                <option :value="false">Nein</option>
                            </select>
                        </div>
                        <div v-if="sickDay.attested">
                            <label>Bescheinigung eingereicht am</label>
                            <input type="date" v-model="sickDay.attestSubmittedOn">
                        </div>
                        <div v-if="sickDay.usernameRegisteredBy">
                            <label>Eingetragen durch</label>
                            <input type="text" v-model="sickDay.usernameRegisteredBy" readonly>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" @click="saveSickDay">Speichern</button>
                <button @click="closeModal">Schließen</button>
              </div>
        </div>
    </div>
</template>

<script>
import apiService from "@/service";

export default {
    name: "SickDaysEditModal",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        sickDayId: {
            type: Number,
            default: null
        },
        contractId: {
            type: Number,
            default: null
        },
        allSickDays: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            sickDay: {
                id: 0,
                contractId: null,
                startDate: '',
                endDate: null,
                attested: null,
                attestSubmittedOn: null,
                usernameRegisteredBy: ''
            },
            attestedValue: '',
            errors: []
        }
    },
    computed: {
        title(){
            if(this.sickDayId)
                return "Krankheitstag(e) bearbeiten";
            else
                return "Krankheitstag(e) hinzufügen";
        },
        isVisible(){
            return this.show;
        }
    },
    methods: {
        getSickDay(){
            apiService.get(`/SickDays/GetById?id=${this.sickDayId}`)
                .then(response => {
                    let item = response.data;
                    this.sickDay = {
                        id: item.id,
                        contractId: item.contractId,
                        startDate: item.startDate.split("T")[0],
                        endDate: item.endDate ? item.endDate.split("T")[0] : "-",
                        attested: item.attested,
                        attestSubmittedOn: item.attestSubmittedOn ? item.attestSubmittedOn.split("T")[0] : "-",
                        usernameRegisteredBy: item.usernameRegisteredBy
                    };
                })
                .catch(() => {
                    console.log("Error getting SickDay!");
                })
        },
        closeModal(){
            this.$emit("close");
        },
        updateOverview(){
            this.$emit("update");
            this.closeModal();
        },
        getUsername(){
            var jsonString = localStorage.getItem('userData');
            var userData = jsonString ? JSON.parse(jsonString) : null;
            return userData.name;
        },
        async saveSickDay(){
            let url = null;

            if(this.sickDayId){
                url = `/SickDays/Update`;
            }
            else{
                url = "/SickDays/Insert";
            }

            if(!this.sickDay.attested){
                this.sickDay.attestSubmittedOn = null;
            }

            if(!(await this.validateInput()))
                return;

            apiService.post(url, this.sickDay)
                .then(() => {
                    this.updateOverview();
                })
                .catch(error => {
                    console.log("Error on saving sick day! Error: " + error);
                });
        },
        async getContract(){
            return (await apiService.get(`/ContractWorktime/GetById?id=${this.contractId}`)).data;
        },
        async validateInput(){
            this.errors = [];

            let contract = await this.getContract();

            let currentStartDate = this.sickDay.startDate ? new Date(new Date(this.sickDay.startDate).toDateString()) : null;
            let currentEndDate = this.sickDay.endDate ? new Date(new Date(this.sickDay.endDate).toDateString()) : null;

            let contractCurrentStartDate = new Date(new Date(contract.contractStart).toDateString());

            if(!currentStartDate)
            {
                this.errors.push("Ein Startdatum muss gesetzt sein!");
                return false;
            }

            if(currentEndDate && currentEndDate < currentStartDate)
                this.errors.push("Der letzte Tag kann nicht vor dem ersten Tag liegen!");

            if(this.sickDay.attested == null)
                this.errors.push("Es muss eine Auswahl getroffen werden, ob eine Arbeitsunfähigkeitsbescheinigung vorliegt!")
            
            if(currentStartDate && currentStartDate < contractCurrentStartDate)
                this.errors.push(`Der erste Tag kann nicht vor dem Vertragsstart liegen (Vertragsstart: ${new Intl.DateTimeFormat("de-DE", {month:'2-digit',day:'2-digit', year:'numeric'}).format(new Date(contract.contractStart))})!`);

            let overlappingElements = [];
            this.allSickDays.forEach(element => {
                if(this.sickDayId && element.id == this.sickDayId)
                    return;

                let elementStartDate = new Date(new Date(element.startDateOrig).toDateString());
                let elementEndDate = element.endDateOrig ? new Date(new Date(element.endDateOrig).toDateString()) : null;

                if(((elementEndDate ? elementEndDate > currentStartDate : true) && (currentEndDate ? elementStartDate < currentEndDate : true) || (!currentEndDate && !elementEndDate)))
                    overlappingElements.push(element);
            });

            for(let i = 0; (i < 3 && i < overlappingElements.length); i++){
                let element = overlappingElements[i];
                this.errors.push(`Der Zeitraum der Krankheit überlappt mit dem Zeitraum einer anderen Krankheitsdauer (${element.startDate} - ${element.endDate ? element.endDate : "offen"})!`);
            }

            return this.errors.length == 0;
        }
    },
    mounted() {
        if(this.sickDayId)
        {
            this.getSickDay();
        }
        else{
            this.sickDay.contractId = this.contractId;
            this.sickDay.usernameRegisteredBy = this.getUsername();
        }
    }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background: #fff;
  padding: 2rem;
  border-radius: 5px;
  width: 600px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  margin: 15px 0;
}

.button-footer button {
    margin-left: 5px;
}

.button-footer button:hover {
    cursor: pointer;
    background-color: #c0c0c0;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #4d4d4d;
}

.btn-close:hover {
  color: #c0c0c0;
}

.modal-footer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.modal-footer button {
  border: none;
  background-color: #4d4d4d;
  border-radius: 5px;
  font-size: 1rem;
  color: white;
  font-weight: 600;
  padding: .5rem .75rem;
}

.modal-footer button:hover {
  cursor: pointer;
  background-color: #c0c0c0;
}

.form-create {
    margin: auto;
    /* width: 30%; */
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.form-create h2 {
    text-align: center;
    font-size: 2rem;
    margin-bottom: 1rem;
}

.form-create form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.form-create label,
.form-create input,
.form-create select {
    display: block;
    width: 100%;
}

.form-create input,
.form-create button,
.form-create select {
    padding: .5rem .75rem;
}

.form-create label {
    margin-bottom: .5rem;
    font-weight: 600
}

.form-create input:focus-visible,
.form-create select:focus-visible {
    outline: 3px solid #5b97d484;
    border-radius: 2px;
}

.validation {
    border: 5px solid red;
    padding: 10px;
    margin-bottom: 10px;
}
</style>